import { route } from '@/constants/routeName';

import i1 from '@/assets/icons/menus/1. edit-profile.png';
import i2 from '@/assets/icons/menus/2. user-list.png';
// import i3 from '@/assets/icons/menus/3. temporary-user.png';
import i4 from '@/assets/icons/menus/4. code-management.png';
import i5 from '@/assets/icons/menus/5. category-list.png';
import i6 from '@/assets/icons/menus/6. list-file.png';
import i7 from '@/assets/icons/menus/7. download-list.png';
// import i8 from '@/assets/icons/menus/8. status-type.png';
// import i9 from '@/assets/icons/menus/9. reference-list.png';
// import i10 from '@/assets/icons/menus/10. list-file.png';
import i11 from '@/assets/icons/menus/11. user-guide.png';
import i12 from '@/assets/icons/menus/12. user-logout.png';

export const menuItems = [
	{
		id: 1,
		name: 'Edit your profile',
		label: 'Endre profil',
		url: route.user,
		icon: i1,
		privileges: null,
	},
	{
		id: 2,
		name: 'Brukerliste',
		label: 'Brukerliste',
		url: route.users,
		icon: i2,
		privileges: [1, 2, 9],
	},
	// {
	// 	id: 3,
	// 	name: 'Midlertidig brukerliste',
	// 	label: 'Midlertidig brukerliste',
	// 	url: route.tempUsers,
	// 	icon: i3,
	// 	privileges: [1, 2],
	// },
	{
		id: 4,
		name: 'Kodeliste',
		label: 'Kodeliste',
		url: route.codes,
		icon: i4,
		privileges: [1, 2, 9],
	},
	{
		id: 4,
		name: 'Group',
		label: 'Group',
		url: route.groups,
		icon: i5,
		privileges: [1, 2, 9],
	},
	{
		id: 5,
		name: 'Kategorier',
		label: 'Kategorier',
		url: route.categories,
		icon: i5,
		privileges: [1, 2, 9],
	},
	{
		id: 6,
		name: 'Vedleggsoversikt',
		label: 'Vedleggsoversikt',
		url: route.dataSheets,
		icon: i6,
		privileges: [1, 2, 9],
	},
	{
		id: 7,
		name: 'Nedlastingslogg',
		label: 'Nedlastingslogg',
		url: route.downloads,
		icon: i7,
		privileges: [1, 2, 9],
	},
	// {
	// 	id: 8,
	// 	name: 'Status',
	// 	label: 'Status',
	// 	url: route.status,
	// 	icon: i8,
	// 	privileges: [1, 2],
	// },
	// {
	// 	id: 9,
	// 	name: 'Referanse',
	// 	label: 'Referanse',
	// 	url: route.reference,
	// 	icon: i9,
	// 	privileges: [1, 2],
	// },
	// {
	// 	id: 10,
	// 	name: 'Datasheet',
	// 	label: 'Datasheet (Missing)',
	// 	url: route.user,
	// 	icon: i10,
	// 	privileges: [1, 2],
	// },
	{
		id: 11,
		name: 'Projects',
		label: 'Prosjekter',
		url: route.projects,
		icon: i6,
		privileges: [1, 2, 99],
	},
	{
		id: 11,
		name: 'User guide',
		label: 'User guide',
		url: route.userGuide,
		icon: i11,
		privileges: [1, 2, 3, 4, 5, 6, 7, 9, 99],
	},
	{
		id: 12,
		name: 'Logg ut',
		label: 'Logg ut',
		url: null,
		icon: i12,
		privileges: null,
	},
];
